import DownloadIcons from './DownloadIcons/DownloadIcons';

export default DownloadIcons;
